import { useState } from "react";
import useReveal from "../shared/useReveal";
import "./ContactCta.css";

const INTERESTS = [
  "Portfolio Review",
  "Mutual Fund Wealth Management",
  "Bonds",
  "Unlisted Shares",
  "IPO Advisory",
  "Algo Trading",
  "Business Finance / Loans",
  "Company Registration",
  "Tax Planning",
  "Insurance",
];

export default function ContactCta() {
  const ref = useReveal();
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setSubmitted(true);
  }

  return (
    <section className="section" id="contact-cta">
      <div className="container" ref={ref}>
        <div className="home-cta-band pm-reveal">
          <div>
            <h2>Your money deserves a mitra.</h2>
            <p>
              Book a free consultation or request a callback — an expert (not a
              salesperson) will call you within one working day.
            </p>
            <div className="home-cta-perks">
              <span>✓ No obligation</span>
              <span>✓ No hidden charges</span>
              <span>✓ Honest advice</span>
            </div>
          </div>

          {submitted ? (
            <div className="home-form-ok" role="status">
              ✅ Thank you! Our team will call you within one working day.
            </div>
          ) : (
            <form className="home-contact-form" onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Your name" required />
              <input
                type="tel"
                name="phone"
                placeholder="Mobile number"
                pattern="[0-9+ ]{10,13}"
                required
              />
              <select name="interest" required defaultValue="">
                <option value="" disabled>
                  I&apos;m interested in…
                </option>
                {INTERESTS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
              <button className="btn btn-gold" type="submit">
                Request a Callback
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
